import TextField from './text-field'

export default TextField


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/components/text-field/index.js
// module id = null
// module chunks = 